import { render } from "./ManageClients.vue?vue&type=template&id=6fc6f7e0"
import script from "./ManageClients.vue?vue&type=script&lang=js"
export * from "./ManageClients.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__